<template style="height:100%">
  <div class="Chart">
    <div class="left">
      <h2 style="font-size: 16px;padding:15px">量表</h2>
      <scales @sendmsg="getmsg"></scales>
    </div>

    <div class="right">
      <el-button type="primary" style="margin-left:15px;margin-top:15px;" @click="add()">新增</el-button>
      <h2 style="font-size: 16px;padding:15px">下级量表分类列表</h2>
        <el-table :data="tableData" style="width: 98%;margin-left:1%">

          <el-table-column prop="statisitcChartName" label="统计图表标题" width="180"></el-table-column>
          <el-table-column prop="remark" label="图表类型"></el-table-column>
          <el-table-column prop="lineNumber" label="排序"></el-table-column>
          <el-table-column prop="isActive" label="是否启用">

            <template slot-scope="scope">
              <span v-if="scope.row">
                {{scope.row.isActive==1?'启用':'未启用'}}
              </span>
            </template>
          </el-table-column>

          <el-table-column label="操作">
            <template slot-scope="scope">
              <span @click="jlk(scope.row)">
                修改
              </span>
              <!-- <span v-if="scope.row">
                删除
              </span> -->
            </template>
          </el-table-column>
        </el-table>
        <!-- <pagination :msgToChild="msg" @send="sendmsg2"></pagination> -->

    </div>
  </div>
</template>
<script>
import scales from '@/components/scales.vue'
import pagination from '@/components/pagination.vue'
  export default {
    data() {
      return {
        msg:{
          pageIndex:1,
          Counts:10,
        },
        tableData: []
      };
    },
    components:{
      scales,
      pagination
    },
    methods: {
      jlk(a){
        console.log(a)
        this.$router.push({
          path: '/statement/Chart_add',
          query: { chartId: a.chartId,paperId:a.paperId},
        })
      },
      getmsg(val){//量表点击时子组件传过来值
        this.$Http_Get('reportChartsCng/getPaperClassificationList', { paperId:val}).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.tableData = res.Data
          }else{
            this.Global.request_failure(res.Message);
          }
        });
      },
      // sendmsg2(val){//量表点击时子组件传过来值

      // },
      add(){
        this.$router.push({
          path: '/statement/Chart_add',
        })
      },
      handleClick(tab, event) {

      },
    }
  };
</script>
<style>
.Chart{width: 100%;height: 100%;}
.Chart .left{width: 350px;height: 100%;background-color: #fff;float: left;}
.Chart .right{width: calc(100% - 365px);float: right;background-color: #fff;height: 100%;}
</style>